module.exports = __webpack_public_path__ + "media/images/home/ic_events-04307eec86d52883eac98ab305ff2c22.svg";